import { EntityRequestAddchg } from "../../entity/EntityRequestAddchg";

export class DtoRequestAddchgsPutRes extends EntityRequestAddchg {}
